module.exports = __webpack_public_path__ + "img/data-tables-anatomy.f315baf5.svg";